module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Tags")]), _vm._m(0), _c('br'), _c('br'), _c('new-tag', {
    on: {
      "created": _vm.tagCreated
    }
  }), _c('list', {
    ref: "list",
    attrs: {
      "options": {
        top_border: true
      },
      "list_item_options": _vm.list_item_options
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "light-gray-text light-text"
  }, [_vm._v("Crie tags personalizadas por nome e cor para classificar seus contatos. "), _c('br'), _vm._v("As tags estarão disponíveis para todo o time de vendas.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-672397e8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tags/index.vue
// module id = 1155
// module chunks = 1